/**
 * @file コンポーネント：協賛企業リスト スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル
export const StyledPartnerlist = styled.ul`
    display: flex;
    flex-wrap: wrap;
`;

export const StyledPartnerlistAnchor = styled.a``;

export const StyledPartnerlistImage = styled.img`
    width: 164px;
    height: 82px;
`;

export const StyledPartnerlistItem = styled.li`
    margin: 0 8px 8px 0;
`;
